import * as type from './types';

export function login(data) {
    return {
      type: type.POST_LOGIN_REQUESTED,
      data:data,
    }
  }

export function clearLoginError() {
    return {
      type: type.CLEAR_LOGIN_ERROR,
    }
  }